
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/settings",
      function () {
        return require("private-next-pages/student/settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/settings"])
      });
    }
  